// @flow

const RoutesURL = {
  // Navigational routes
  main:             () => '/',
  login:            () => '/session/login',
  logout:           () => '/session/logout',
  settings:         () => '/settings',
  special_deals:    () => '/special-deals',
  help:             () => '/help',
  company_branding: (unique_company_seo: string = '', app_id: any = '') => '/company-branding/' + unique_company_seo + '/' + app_id,
  flow:             () => window.URL_BASE,

};

export default RoutesURL;



// WEBPACK FOOTER //
// ./src/routes/routes.js